module.exports = __webpack_public_path__ + "img/bild-g.34642e02.png";